import React, { useState, useEffect, useRef } from 'react';
import './login.css'
import ArrowBack from '../../assets/icons/arrow-back.svg'
import Eye from '../../assets/icons/eye.svg'
import HideEye from '../../assets/icons/close-eye.svg'
import BlueLogo from '../../assets/images/blue-logo.svg'
import { Form } from 'react-bootstrap';
import 'primeicons/primeicons.css';
import { IsMobileExsits, sendOtp, loginByPass, loginByOtp } from "../../utils/api"
import Loader from '../loader/loader'
import { Toast } from 'primereact/toast';
import { useDispatch } from 'react-redux';
import useToastNotification from '../../hooks/useToastNotification';
import EditIcon from '../../assets/icons/panel/edit.svg'


function Login() {
  const toast = useRef(null);
  const dispatch = useDispatch();

  const [mobileSection, setMobileSection] = useState(true)
  const [OTPSection, setOTPSection] = useState(false)
  const [PasswordSection, setPasswordSection] = useState(false)
  const [typePassword, setTypePassword] = useState('password');
  const [time, setTime] = useState(240); // Initialize with 2 minutes (120 seconds)
  const [isActive, setIsActive] = useState(false);
  const [resendBtn, setResendBtn] = useState(true);
  const [resendCode, setResendCode] = useState(false);
  const [checkMobileLoader, setCheckMobileLoader] = useState(false);
  const [otpLoader, setOtpLoader] = useState(false);
  const [passwordLoader, setPasswordLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [validatedOtp, setValidatedOtp] = useState(false);
  const [password, setPassword] = useState('');
  const [otpPassword, setOtpPassword] = useState('');

  //field
  const [mobile, setMobile] = useState('');

  const { showError, showSuccess } = useToastNotification();


  //checkMobile
  const checkMobile = async () => {
    setCheckMobileLoader(true)
    if (mobile.length == 11 && mobile.startsWith("09")) {
      try {
        let pay = {
          mobile: mobile
        }
        let res = await IsMobileExsits(pay)
        if (res.statusText == "OK") {
          if (res.data.isSuccess) {
            let message = {
              text: res.data.message
            }
            showSuccess(message)
            setCheckMobileLoader(false)
            setMobileSection(false)
            setOTPSection(true)
            setPasswordSection(false)
            sendOtpfunction()
          } else {
            setCheckMobileLoader(false)
            let message = {
              text: res.data.message
            }
            showSuccess(message)
            window.location.href = `/sign-up?mobile=${mobile}`
          }
        }

      } catch (error) {
        setCheckMobileLoader(false)

        let message = {
          text: 'خطا در ارتباط با سرور'
        }
        showError(message)
      }
    } else {
      let message = {
        text: 'لطفا شماره موبایل را به صورت صحیح وارد کنید.'
      }
      showError(message)
      setCheckMobileLoader(false)
    }

  }

  //sendOtp
  const sendOtpfunction = async () => {

    try {
      setTime(240)
      setIsActive(true);
      setResendCode(true);
      setResendBtn(true);
      let res = await sendOtp({
        mobile
      })

      if (!res.data.isSuccess) {
        let message = {
          text: res.data.message
        }
        showError(message)
      }
    } catch (error) {
      let errorMessage = error.response.data.error
      let message = {
        text: errorMessage
      }
      showError(message)
    }
  }


  //loginbypass
  const loginByPassWord = async (e) => {
    e.preventDefault();
    setPasswordLoader(true)
    const form = e.currentTarget;
    if (form.checkValidity() === true) {
      try {
        let pay = {
          password,
          mobile
        }
        let res = await loginByPass(pay)
        if (res.statusText == "OK") {
          if (res.data.isSuccess) {
            setPasswordLoader(false)
            localStorage.setItem('token', JSON.stringify(res.data.data.token))
            localStorage.setItem('userData', JSON.stringify(res.data.data))
            dispatch({ type: 'SET_CUSTOMER_DATA', payload: res.data.data });

            // ✅ ایونت استاندارد GA4 برای لاگین موفق با رمز
if (typeof window.gtag === 'function') {
  window.gtag('event', 'login', {
    method: 'password',
    // فقط 4 رقم آخر برای رعایت حریم خصوصی
    mobile_last4: (mobile || '').toString().slice(-4),
    debug_mode: true, // برای DebugView (بعداً می‌توانید بردارید)
  });
}
            window.location.href = `/`
            let message = {
              text: res.data.message
            }
            showSuccess(message)

          } else {
            setPasswordLoader(false)
            let message = {
              text: res.data.message
            }
            showError(message)
            // window.location.href = `/sign-up?mobile=${mobile}`
          }

        }
      } catch (error) {
        setPasswordLoader(false)
        let message = {
          text: 'خطا در ارتباط با سرور'
        }
        showError(message)
      }

    }
    setValidated(true);

  }
  //loginbypass
  const funcLoginByOtp = async (e) => {
    e.preventDefault();
    setOtpLoader(true)
    const form = e.currentTarget;
    if (form.checkValidity() === true) {
      if (otpPassword.length == 6) {
        try {
          let pay = {
            otp: otpPassword,
            mobile
          }
          let res = await loginByOtp(pay)
          if (res.statusText == "OK") {
            if (res.data.isSuccess) {
              setOtpLoader(false)
              localStorage.setItem('token', JSON.stringify(res.data.data.token))
              localStorage.setItem('userData', JSON.stringify(res.data.data))
              dispatch({ type: 'SET_CUSTOMER_DATA', payload: res.data.data });
              // ✅ ایونت استاندارد GA4 برای لاگین موفق با OTP
if (typeof window.gtag === 'function') {
  window.gtag('event', 'login', {
    method: 'otp',
    mobile_last4: (mobile || '').toString().slice(-4),
    debug_mode: true,
  });
}
              window.location.href = `/`
              let message = {
                text: res.data.message
              }
              showSuccess(message)

            } else {
              setOtpLoader(false)
              let message = {
                text: res.data.message
              }
              showError(message)
            }

          }
        } catch (error) {
          setOtpLoader(false)
          let message = {
            text: 'خطا در ارتباط با سرور'
          }
          showError(message)
        }
      } else {
        setOtpLoader(false)
        let message = {
          text: 'لطفا کد ارسال شده را صحیح وارد کنید.'
        }
        showError(message)
      }


    }
    setValidatedOtp(true);

  }
  const gotoPasswordSection = () => {
    setMobileSection(false)
    setOTPSection(false)
    setPasswordSection(true)

  }
  const gotoOTPSection = () => {
    setMobileSection(false)
    setOTPSection(true)
    setPasswordSection(false)
    sendOtpfunction()
  }
  const showPassword = () => {
    setTypePassword('text')
  }
  const hidePassword = () => {
    setTypePassword('password')
  }


  //setTimer
  useEffect(() => {
    let timerId;
    if (isActive && time > 0) {
      timerId = setInterval(() => {
        setTime(prevTime => prevTime - 1);
      }, 1000);
    } else if (time === 0) {
      onTimerFinish(); // Call the function when the timer reaches 0
    }
    // Cleanup interval on component unmount or when time reaches 0
    return () => clearInterval(timerId);
  }, [isActive, time]);

  //finishTimer
  const onTimerFinish = () => {
    setResendCode(true);
    setResendBtn(false);
  }

  const formatTime = (time) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, '0');
    const seconds = String(time % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }
  return (
    <>
      <Toast ref={toast} />
      <div>
        <div className='body-login container mt-0'>
          {mobileSection &&
            <div className='login-card'>
              <button className='btn btn-primary d-flex back-btn' onClick={() => window.location.href = '/'} > <img src={ArrowBack} className='ml-2' alt="" />بازگشت</button>

              <div className='item' style={{ marginTop: '6em' }}>
                <div className='d-flex align-items-center f-32 font-black color-primary title3 gap-2'><img src={BlueLogo} alt="" />به کادونا خوش آمدید</div>
                <h6 className='text-xl text-end font-medium	color-primary2 mt-5'>برای ورود لطفا شماره موبایل خود را وارد کنید.</h6>
                <Form className='mt-5'>
                  <Form.Group controlId="text" >
                    <Form.Label style={{ fontWeight: '600' }}>شماره موبایل</Form.Label>
                    <Form.Control type="number" inputMode="numeric" value={mobile} onChange={(e) => {
                      if (e.target.value.length <= 11) {
                        setMobile(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                      }
                    }} onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent form submission
                        checkMobile(e); // Call login function
                      }
                    }} />
                  </Form.Group>
                  <h5 className='mt-5 color-primary text-base'>ورود شما به معنای <a>پذیرش شرایط کادونا و قوانین حریم خصوصی</a> است.</h5>
                  <button className='btn btn-primary w-100 mt-1 text-center' disabled={checkMobileLoader} onClick={checkMobile} type='button' style={{ width: 'auto' }}>ورود {checkMobileLoader && <Loader />}</button>
                </Form>
              </div>
            </div>
          }


          {OTPSection &&
            <div className='login-card'>
              <button className='btn btn-primary d-flex back-btn' onClick={() => {
                setMobileSection(true); // بازگشت به بخش ورود شماره موبایل
                setOTPSection(false);
              }}> <img src={ArrowBack} className='ml-2' alt="" />بازگشت</button>
              <div className='item' style={{ marginTop: '6em' }}>
                <div className='d-flex align-items-center f-32 font-black color-primary title3 gap-2'><img src={BlueLogo} alt="" />به کادونا خوش آمدید</div>
                <h6 className='text-xl font-medium	color-primary2 mt-5 '>کد تایید ارسالی  برای شماره <br className='mobile'/><button type='button' style={{marginBottom: '8px',paddingRight: '0'}} className='btn text-center color-primary' onClick={() => {
                                setMobileSection(true); // بازگشت به بخش ورود شماره موبایل
                                setOTPSection(false);
                            }}><img src={EditIcon}/></button>{mobile} را وارد کنید.</h6>
                <Form className='mt-5' noValidate validated={validatedOtp} onSubmit={(e) => funcLoginByOtp(e)}>
                  <Form.Group controlId="postalCode">
                    <Form.Label style={{ fontWeight: '600' }}>کد تایید</Form.Label>
                    <Form.Control className='number' id="loginOtp"
                      name="loginOtp" type="number" autocomplete="one-time-code" inputMode="numeric" required value={otpPassword} onChange={(e) => {
                        if (e.target.value.length <= 6) {
                          setOtpPassword(e.target.value); // محدود کردن مقدار به 11 کاراکتر
                        }
                      }} onKeyDown={(e) => {

                        if (e.key === 'Enter') {
                          e.preventDefault(); // Prevent form submission
                          funcLoginByOtp(e); // Call login function
                        }
                      }} />

                  </Form.Group>

                  <button type='button' disabled={resendBtn} className='btn w-100 text-center mt-2' onClick={(e) => sendOtpfunction(mobile)}> {!resendBtn ? 'ارسال مجدد' : formatTime(time)}</button>
                  <button className='btn btn-primary mt-4 w-100 mt-1 text-center' type='submit' disabled={otpLoader} style={{ width: 'auto' }}>تایید {otpLoader && <Loader />}</button>

                  <button type='button' className='btn w-100 text-center color-primary' onClick={gotoPasswordSection}>ورود با رمز عبور</button>
             
                </Form>
              </div>
            </div>
          }

          {PasswordSection &&
            <div className='login-card'>
              <button className='btn btn-primary d-flex back-btn' onClick={() => {
                setMobileSection(true); // بازگشت به بخش ورود شماره موبایل
                setPasswordSection(false);
              }}> <img src={ArrowBack} className='ml-2' alt="" />بازگشت</button>
              <div className='item' style={{ marginTop: '6em' }}>
                <div className='d-flex align-items-center f-32 font-black color-primary title3 gap-2'><img src={BlueLogo} alt="" />به کادونا خوش آمدید</div>
                <h6 className='text-xl font-medium	color-primary2 mt-5'>رمز عبور را وارد کنید.</h6>
                <Form className='mt-5' noValidate validated={validated} onSubmit={(e) => loginByPassWord(e)}>
                  <Form.Group controlId="text" >
                    <Form.Label style={{ fontWeight: '600' }}>رمزعبور</Form.Label>
                    <div className='input-icon'>
                      <Form.Control type={typePassword} required value={password} onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={(e) => {

                          if (e.key === 'Enter') {
                            e.preventDefault(); // Prevent form submission
                            loginByPassWord(e); // Call login function
                          }
                        }} />
                      {typePassword === 'password' ? <img src={Eye} alt="" onClick={showPassword} /> : <img src={HideEye} alt="" onClick={hidePassword} />}
                    </div>
                  </Form.Group>
                  <button className='btn btn-primary mt-4 w-100 mt-1 text-center' disabled={passwordLoader} type='submit' style={{ width: 'auto' }}>تایید {passwordLoader && <Loader />}</button>
                  <div>
                    <button type='button' className='btn w-100 text-center color-primary mt-2' onClick={gotoOTPSection}>ورود با رمز یکبار مصرف</button>
                    <button type='button' className='btn w-100 text-center color-primary ' onClick={(e) => { window.location.href = '/change-password' }}>فراموشی رمز عبور</button>
                  </div>



                </Form>
              </div>
            </div>
          }
        </div>
      </div>


    </>
  )

}
export default Login;
